import { attr, hasMany } from '@ember-data/model';
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
import NumericEnum from '@square/dashboard-utilities/utils/numeric-enum';
const StraightFireType = NumericEnum.create(['UNKNOWN', 'NEVER', 'ALWAYS']);
export const CategoryType = NumericEnum.create(['CATALOG_CATEGORY_TYPE_DO_NOT_USE', 'REGULAR_CATEGORY', 'MENU_CATEGORY', 'KITCHEN_CATEGORY']);
const PAGE_SIZE = 100;
export default ItemsV3Base.extend({
  enabledUnitsAll: attr('boolean', {
    allowNull: true,
    defaultValue: true
  }),
  name: attr('string'),
  items: hasMany('item', {
    async: false
  }),
  ordinal: attr('number'),
  straightFire: attr('enum', {
    enumClass: StraightFireType
  }),
  categoryType: attr('enum', {
    enumClass: CategoryType
  }),
  menuCategoryId: attr('string')
}).reopenClass({
  _modelNameForMigration: 'category',
  catalogType() {
    return 'CATEGORY';
  },
  sortKey: 'name',
  currentUserAffectsEnabledUnitsAll: false,
  StraightFireType,
  PAGE_SIZE
});